<template>
  <div>
    <tci-service-head :title="$t('service.service2.title')" :subtitle="$t('service.service2.subtitle')" :content="$t('service.service2.content')" :imgUrl='$i18n.locale=="zh"?require("../assets/service/s2-1.jpg"):require("../assets/service/s2-1-ja.jpg")'>
    </tci-service-head> 
    <tci-contact-footer color="white"></tci-contact-footer>
  </div>
</template>

<script>
import TciContactFooter from "@/components/TciContactFooter.vue";
import TciServiceHead from "@/components/TciServiceHead.vue";

export default {
  name: "CompanyService2",
  components: {
    "tci-contact-footer": TciContactFooter,
    "tci-service-head": TciServiceHead
  }
};
</script>
